import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { RequestStatus } from 'clickNgo/configs/service/common'

import { requestApi } from '../features/api/requestApi'
import { selectParentRequestData } from '../features/selectors/selectParentRequestData'

export const useParentRequest = (requestId: number | null) => {
  const dispatch = useAppDispatch()
  const { data: parentRequest, meta, status } = useSelector(selectParentRequestData)

  useEffect(() => {
    if (requestId && (!meta || meta.arg?.['requestId'] !== requestId)) {
      dispatch(requestApi.getParentRequest({ requestId }))
    }
  }, [requestId, meta, dispatch])

  return {
    parentRequest,
    parentRequestWip: status === RequestStatus.PENDING,
  }
}
